import linkifyHtml from "linkify-html";
import React from "react";

const AboutSection = ({
  about,
  members,
  setCurrentSelectedUserId,
  handleUserclickedOnAbout,
}) => {
  const linkifiedGroupDescription = linkifyHtml(about.about, {
    target: "_blank",
    rel: "noopener noreferrer",
    attributes: {
      style: "color: primary;",
    },
  });
  if (!about) {
    return (
      <div style={{ color: "#fff", padding: "20px", textAlign: "center" }}>
        Loading group details...
      </div>
    );
  }

  return (
    <div>
      {/* About Card */}
      <div
        className="journal-card"
        style={{
          backgroundColor: "#1C2A37",
          borderRadius: "24px",
          margin: "0 24px 31px",
          color: "#D0D8DF",
        }}
      >
        <div>
          <div className="text-heading-h3" style={{ fontSize: "20px" }}>
            About
          </div>
          <br />
          <div
            style={{
              fontSize: "14px",
              fontWeight: "500",
              marginBottom: "16px",
            }}
          >
            {about.name}
          </div>
          <p
            // className="d-flex align-items-center"
            style={{ fontSize: "12px", fontWeight: "400", textAlign: "left" }}
            dangerouslySetInnerHTML={{
              __html:
                linkifiedGroupDescription ||
                "No description available for this group.",
            }}
          />
        </div>
      </div>

      {/* Members Card */}
      <div
        className="journal-card"
        style={{
          backgroundColor: "#1C2A37",
          borderRadius: "24px",
          margin: "0 24px 31px",
          color: "#D0D8DF",
        }}
      >
        <div>
          <div
            className="text-heading-h3"
            style={{ fontSize: "20px", marginBottom: "20px" }}
          >
            Members ({members?.length || 0})
          </div>

          {members && members.length > 0 ? (
            members.map((member) => (
              <div
                key={member.user.id}
                style={{
                  fontSize: "20px",
                  marginBottom: "16px",
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                }}
                onClick={() => handleUserclickedOnAbout(member.user.id, member)}
              >
                <img
                  src={member.user.image || "/icons/james.svg"}
                  alt={member.user.full_name}
                  style={{
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                    objectFit: "cover",
                  }}
                />
                <span
                  style={{
                    fontWeight: "600",
                    fontSize: "16px",
                    marginLeft: "16px",
                    marginRight: "16px",
                  }}
                >
                  {member.user.full_name}
                </span>
                {member.role === "Admin" && (
                  <span
                    style={{
                      fontSize: "10px",
                      backgroundColor: "#008CFF",
                      padding: "2px 6px",
                      borderRadius: "4px",
                      color: "#fff",
                    }}
                  >
                    Admin
                  </span>

                  // // according to figma design, admin tag
                  // <span className="text-small-s2" style={{ color: "#C8CED3" }}>
                  //   Admin
                  // </span>
                )}
              </div>
            ))
          ) : (
            <div
              style={{ color: "#7E8897", textAlign: "center", padding: "16px" }}
            >
              No members found in this group
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AboutSection;
